import script from "./CoeHeaderComponent.vue?vue&type=script&setup=true&lang=js"
export * from "./CoeHeaderComponent.vue?vue&type=script&setup=true&lang=js"

import "./CoeHeaderComponent.vue?vue&type=style&index=0&id=1ca8c23c&scoped=true&lang=css"

import exportComponent from "D:\\2026\\frontend-melindacvc\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-1ca8c23c"]])

export default __exports__